"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _javascriptTimeAgo = _interopRequireDefault(require("javascript-time-ago"));

var _en = _interopRequireDefault(require("javascript-time-ago/locale/en"));

var _ko = _interopRequireDefault(require("javascript-time-ago/locale/ko"));

var _de = _interopRequireDefault(require("javascript-time-ago/locale/de"));

var _es = _interopRequireDefault(require("javascript-time-ago/locale/es"));

var _fr = _interopRequireDefault(require("javascript-time-ago/locale/fr"));

var _it = _interopRequireDefault(require("javascript-time-ago/locale/it"));

var _ja = _interopRequireDefault(require("javascript-time-ago/locale/ja"));

var _pt = _interopRequireDefault(require("javascript-time-ago/locale/pt"));

var _zh = _interopRequireDefault(require("javascript-time-ago/locale/zh"));

var _dateformat = _interopRequireDefault(require("dateformat"));

var Constants = _interopRequireWildcard(require("../constants/Constants"));

var _store = _interopRequireDefault(require("../store/store"));

var NotificationSelectors = _interopRequireWildcard(require("../store/reducers/NotificationReducer"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _PulseApiHelper = _interopRequireDefault(require("../service/PulseApiHelper"));

var _NotificationsPollService = require("../service/NotificationsPollService");

var _AnnouncementFetcher = require("../service/AnnouncementFetcher");

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var timeAgoInstance;
/**
 * Utility functions for Pulse
 */

var _default = {
  /**
   * Fetch query parameters from a url.
   *
   * @param {string} url Full URL string, ex: https://notify.adobe.io/ans/v2/notifications/timeline?from=1441799196988.
   * @returns {URLSearchParams} Returns the Query param value.
   */
  getQueryParamsFromUrl: function getQueryParamsFromUrl(url) {
    return new URLSearchParams(new URL(url).search);
  },

  /**
   * Fetch a query parameter from a url.
   *
   * @param {string} url Full URL string, ex: https://notify.adobe.io/ans/v2/notifications/timeline?from=1441799196988.
   * @param {string} key Query param name, ex: from.
   * @returns {string} Returns the Query param value, ex: 1441799196988.
   */
  getQueryParamFromUrl: function getQueryParamFromUrl(url, key) {
    return this.getQueryParamsFromUrl(url).get(key);
  },
  formatTimeAgo: function formatTimeAgo(timeInEpocMillis, isShortHand) {
    var locale = NotificationSelectors.getLocale(_store.default.getState());

    switch (locale) {
      case 'ko-KR':
        _javascriptTimeAgo.default.locale(_ko.default);

        break;

      case 'de-DE':
        _javascriptTimeAgo.default.locale(_de.default);

        break;

      case 'es-ES':
        _javascriptTimeAgo.default.locale(_es.default);

        break;

      case 'fr-FR':
        _javascriptTimeAgo.default.locale(_fr.default);

        break;

      case 'it-IT':
        _javascriptTimeAgo.default.locale(_it.default);

        break;

      case 'ja-JP':
        _javascriptTimeAgo.default.locale(_ja.default);

        break;

      case 'pt-BR':
        _javascriptTimeAgo.default.locale(_pt.default);

        break;

      case 'zh-CN':
        _javascriptTimeAgo.default.locale(_zh.default);

        break;

      case 'zh-TW':
        _javascriptTimeAgo.default.locale(_zh.default);

        break;

      default:
        _javascriptTimeAgo.default.locale(_en.default);

        break;
    }

    timeAgoInstance = new _javascriptTimeAgo.default(locale);
    return isShortHand ? timeAgoInstance.format(timeInEpocMillis, {
      flavour: ['tiny']
    }).replace('wk', 'w').replace('yr', 'y') : timeAgoInstance.format(timeInEpocMillis, {
      flavour: ['long']
    });
  },
  isReminderActive: function isReminderActive(timeInMillis) {
    return timeInMillis < NotificationSelectors.getServerTime(_store.default.getState());
  },
  //TODO: Why 3 different methods for formatting time?
  formatTime: function formatTime(timeInEpocMillis) {
    return (0, _dateformat.default)(timeInEpocMillis, Constants.TIME_FORMAT);
  },
  formatReminderTime: function formatReminderTime(timeInEpocMillis) {
    var tommorrow = new Date(Date.now() + 1);
    var reminder = new Date(timeInEpocMillis);
    var isToday = tommorrow.getDate() === reminder.getDate();
    var day = isToday ? 'today' : 'tomorrow';
    var result = "".concat(day, " at ").concat(this.formatTime(timeInEpocMillis));
    return result;
  },
  formatDate: function formatDate(timeInEpocMillis) {
    return "".concat((0, _dateformat.default)(timeInEpocMillis, Constants.DATE_FORMAT), " at ").concat(this.formatTime(timeInEpocMillis));
  },
  getTimeInSeconds: function getTimeInSeconds() {
    return parseInt(String(Date.now() / 1000));
  },
  validateUrl: function validateUrl(str) {
    //validate and retun false for empty input and url not following pattern with https:// or http:// 
    var regex = /^(http|https):\/\/.*/;
    return regex.test(str);
  },

  /**
   * Calculate if the earlier header has scrolled up  and reached up to new header.
   *
   * @param {*} topOffset
   * @param {*} earlierPosition
   * @param {*} newPosition
   */
  isEarlierSectionHeader: function isEarlierSectionHeader(topOffset, earlierPosition, newPosition) {
    if ((earlierPosition || earlierPosition === 0) && (newPosition || newPosition === 0)) {
      return topOffset >= earlierPosition - newPosition;
    } // check if the user has scrolled up to difference between earlier and new header
    else return false;
  },

  /**
   * Filter the announcements and group them into new and earlier by comparing timestamp.
   *
   * @param {JSONArray} announcements : sorted list of announcements.
   * @param {timeinEpocSeconds} lastTimeStamp : timestamp of announcement to be found.
   */
  filterAnnouncements: function filterAnnouncements(announcements, lastTimeStamp) {
    var newAnnouncement = (0, _filter.default)(announcements, function (item) {
      return item.createTimeStamp > lastTimeStamp;
    }),
        earlierAnnouncement = (0, _filter.default)(announcements, function (item) {
      return item.createTimeStamp < lastTimeStamp;
    });
    return {
      new: newAnnouncement,
      earlier: earlierAnnouncement
    };
  },
  getNotificationsLocaleMapper: function getNotificationsLocaleMapper(locale) {
    switch (locale) {
      case 'de-DE':
        return 'de_DE';

      case 'es-ES':
        return 'es_ES';

      case 'fr-FR':
        return 'fr_FR';

      case 'it-IT':
        return 'it_IT';

      case 'ja-JP':
        return 'ja_JP';

      case 'ko-KR':
        return 'ko_KR';

      case 'pt-BR':
        return 'pt_BR';

      case 'zh-CN':
        return 'zh_CN';

      case 'zh-TW':
        return 'zh_TW';

      default:
        return 'en_US';
    }
  },
  getServerTimeFromNow: function getServerTimeFromNow(serverTimestamp, clientTimestamp) {
    return serverTimestamp + Date.now() - clientTimestamp;
  },
  isTextOverFlown: function isTextOverFlown(textRef) {
    return textRef.current && textRef.current.offsetHeight < textRef.current.scrollHeight;
  },
  getTenantFromPath: function getTenantFromPath(path) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return /^#?((?:\/@([^/]+))?)/.exec(path)[name ? 2 : 1];
  },

  /**
  * Returns the full Unified Shell url with the workspace or nav item `path`
  * appended to the end. Meaning, a path of `/preferences` would
  * become https://experience.adobe.com/#/@tenant/preferences.
  * @param {string} path Relative url of workspace or nav item.
  * @returns {string} Full Unified Shell url with workspace or nav item path.
  */
  getFullUrl: function getFullUrl(path) {
    var hash = window.location.hash;
    var tenant = this.getTenantFromPath(hash);
    return "".concat(_PulseApiHelper.default.getCurrentHostUrl(), "/#").concat(tenant).concat(path);
  },

  /**
   * stop the Notifications and Announcements polling when the
   * tab is inactive.
   * start the Notifications and Announcements polling when the 
   * tab is active.
   * @param notificationPoller 
   * @param announcementPoller 
   */
  onVisibilityChange: function onVisibilityChange(notificationPoller, announcementPoller) {
    if (document.visibilityState === 'hidden') {
      notificationPoller && notificationPoller.stop();
      announcementPoller && announcementPoller.stop();
    } else {
      if (document.visibilityState === 'visible') {
        (0, _NotificationsPollService.getNotifications)(_store.default);
        (0, _AnnouncementFetcher.fetchAnnouncements)(_store.default);
        notificationPoller && notificationPoller.start();
        announcementPoller && announcementPoller.start();
      }
    }
  }
};
exports.default = _default;